var map = {
	"./en-gb": 671,
	"./en-gb.js": 671
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1665;


//////////////////
// WEBPACK FOOTER
// ./~/moment/locale en-gb
// module id = 1665
// module chunks = 1